import { PERFORMANCE_METRIC_STATUSES } from '@shared/constants/checkpoint-performance-report-metric-enums';
import { FieldNames } from './performanceMetricsTableFieldNames';

export const resetTableFieldsMap = referencDatapoint => {
  return new Map([
    [
      PERFORMANCE_METRIC_STATUSES.Update.Id,
      [
        { field: FieldNames.upperLimit, value: referencDatapoint.upperLimit },
        { field: FieldNames.lowerLimit, value: referencDatapoint.lowerLimit }
      ]
    ],
    [PERFORMANCE_METRIC_STATUSES.Skip.Id, sharedRestFields],
    [
      PERFORMANCE_METRIC_STATUSES.NA.Id,
      [...sharedRestFields, { field: FieldNames.notes, value: null }]
    ],
    [PERFORMANCE_METRIC_STATUSES.Discontinue.Id, sharedRestFields]
  ]);
};

const sharedRestFields = [
  { field: FieldNames.upperLimit, value: null },
  { field: FieldNames.lowerLimit, value: null },
  { field: FieldNames.actual, value: null }
];
